import React, { useState } from "react";
import "../../App.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../utilities";
import { encrypt } from "../Reusable_Components/ReusableFunctions";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { CEO_GROUP } from "../../Config";


export const LoginMultitenant = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [termsandConditions, setTermsandConditions] = useState(false)
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [termsandConditionsError, setTermsandConditionsError] = useState("");
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [authError, setAuthError] = useState("");


    const navigate = useNavigate();

    const getGroupName = (group) => {
        switch (group) {
            case CEO_GROUP:
                return "CEO";
            default:
                return "";
        }
    }
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const handleGetStarted = () => {
        navigate("/community-register");
    };

    const handleHome = () => {
        navigate("/home");
    };
    const handleUsername = (e) => {
        setUsername(e.target.value);
        setAuthError("");
        if (e.target.value === '') {
            setUsernameError('Username is required')
        } else if (e.target.value.length < 3) {
            setUsernameError('Username must be at least 3 characters long');
        } else if (/\s/.test(e.target.value)) {
            setUsernameError('Username cannot contain spaces');
        } else if (/[A-Z]/.test(e.target.value)) {
            setUsernameError('Username must be in lowercase');
        } else {
            setUsernameError('')
        }
    };
    const handlePassword = (e) => {
        const value = e.target.value;
        setPassword(value);
        setAuthError("");

        if (value.length === 0) {
            setPasswordError("Password is required");
        } else {
            setPasswordError("");
        }
    };

    const handleLogin = () => {
        if (username === "" || password === "" || termsandConditions === false) {
            if (username === "") {
                setUsernameError("Username is required")
            }
            if (password === "") {
                setPasswordError("Password is required")
            }
            if (termsandConditions === false) {
                setTermsandConditionsError("Please accept the terms and conditions")
            }

        }
        else {
            axios.post(base_url + "authorization/validateUser", encrypt({ username, password }))
                .then((res) => {
                    if (res.status === 200) {
                        localStorage.setItem("group", getGroupName(res.data.data.group))
                        localStorage.setItem("isloggedin", true)
                        localStorage.setItem("access_token", res.data.data.tokens.AccessToken)
                        localStorage.setItem("refresh_token", res.data.data.tokens.RefreshToken)
                        localStorage.setItem("name", res.data.data.name)
                        localStorage.setItem("email", res.data.data.email)
                        localStorage.setItem("username", res.data.data.username)
                        localStorage.setItem("phone_number", res.data.data.phone_number)
                        localStorage.setItem("selected_city_name", "")
                        localStorage.setItem("selected_facility_id", "")
                        localStorage.setItem("selected_facility_name", "")
                        localStorage.setItem("user_id", res.data.data.user_id)
                        localStorage.setItem("org_id", res.data.data.org_id)
                        localStorage.setItem("date_format", res.data.data.date_format)
                        localStorage.setItem("currency_format", res.data.data.currency_format)
                        localStorage.setItem("timezone", res.data.data.timezone)
                        localStorage.setItem("numeric_format", res.data.data.numeric_format)
                        localStorage.setItem("gst_verified", false)
                        navigate("/commercialHeadAddFacility");


                    }

                })
                .catch((error) => {
                    if (error.response) {
                        setAuthError(error.response.data.message);
                    } else {
                        setAuthError("An error occurred. Please try again.");
                    }
                });
        }
    };
    const handleTermsAndConditions = (e) => {
        setTermsandConditions(e.target.checked);
        setTermsandConditionsError("");
    };

    return (
        <div className="registration-page">
            <div className="nav-bar">
                <div className="logo-img">
                    <a href="/home">
                        <img src="./images/icons/PortOSlogo.svg" alt="PortOS logo" style={{ cursor: "pointer" }} />
                    </a>
                </div>
                <div className="nav-links" style={{ justifyContent: "space-between", gap: "40px" }}>
                    <div className="nav-links">
                        <div className="nav-item"><a href="/home" style={{ textDecoration: "none", color: "black" }}>Home</a></div>
                        {/* <div className="nav-item"><a href="/landingpage#features" style={{textDecoration:"none",color:"black"}}>Features</a></div>
                        <div className="nav-item"><a href="#contactus" style={{textDecoration:"none",color:"black"}}>Contact us</a></div>
                        <div className="nav-item"><a href="#pricing" style={{textDecoration:"none",color:"black"}}>Pricing</a></div> */}
                    </div>
                    <div className="signup-button" onClick={handleGetStarted}>
                        <div>Sign Up</div>
                    </div>
                </div>
                <div className="nav-right">
                    <div className="nav-item" onClick={handleHome}>Home</div>
                    <div className="moblielogin-button" onClick={handleGetStarted}>
                        <span style={{ textWrap: 'nowrap' }}>Sign Up</span>
                    </div>
                </div>
            </div>
            <div className="content-container">
                <div className="left-half">
                    <img src="./images/icons/efficiency1.jpg" alt="registration" />
                </div>
                <div className="right-half">
                    <div className="registration-form">
                        <h2>Login to your Organization</h2>
                        {authError && <span className="text-danger">{authError}</span>}
                        <div className="form-group">
                            <label>User Name</label>
                            <input
                                type="text"
                                id="username"
                                className="form-control"
                                onChange={handleUsername}
                            />

                            {usernameError && <span className="text-danger">{usernameError}</span>}

                        </div>
                        <div className="form-group" style={{ position: "relative" }}>
                            <label>Password</label>
                            <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    id="password"
                                    className="form-control"
                                    value={password}
                                    onChange={handlePassword}
                                    style={{ flex: 1, paddingRight: "40px" }}
                                />
                                <span
                                    className="toggle-password-visibility"
                                    onClick={togglePasswordVisibility}
                                    style={{
                                        position: "absolute",
                                        right: "10px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        color: "#555"
                                    }}
                                >
                                    {passwordVisible ? (
                                        <IoEyeOutline size={20} />
                                    ) : (
                                        <IoEyeOffOutline size={20} />
                                    )}
                                </span>
                            </div>
                            {passwordError && <div className="text-danger">{passwordError}</div>}
                            <a
                                href="#"
                                className="forgot-password"
                                onClick={(e) => e.preventDefault()}
                            >
                                Forgot Password?
                            </a>
                        </div>

                        <div className="terms-container">
                            <input
                                type="checkbox"
                                id="terms"
                                name="agreedToTerms"
                                checked={termsandConditions}
                                onChange={handleTermsAndConditions}
                            />

                            <label htmlFor="terms"> Terms and conditions</label>

                        </div>
                        {termsandConditionsError && <span className="text-danger">{termsandConditionsError}</span>}
                        <button className="register-button" onClick={handleLogin}>Log In</button>
                        <a href="#" className="create-account" onClick={handleGetStarted}>Create new account</a>
                    </div>
                </div>
            </div>
        </div>
    );
};